module.exports = __webpack_public_path__ + "img/qs-l3.prt.9c31a943.jpg";